<template>
  <div>
    <div class="navigation-tabs">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label class="label-first">Upload File</label>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group flex">
            <b-form-file v-model="fileUpload" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"></b-form-file>
            <b-overlay :show="isLoadingUpload" class="d-inline-block" rounded opacity="0.6" spinner-small spinner-variant="primary">
              <b-button @click="UploadPPH()" class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">Upload</b-button>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput, BFormFile, BOverlay } from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility'
export default {
  name: "UploadPPHTab",
  props: {
    dataCalculation: {
      type: Object
    }
  },
  components: {
    BCard,
    BRow,
    BButton,
    BFormInput,
    BFormFile,
    BOverlay
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fileUpload:  null,
      isLoadingUpload: false
    }
  },
  methods: {
    UploadPPH() {
      if (this.fileUpload === null) {
        return errorNotification(this, "Oops!", "Tidak Ada File Yang diupload");
      }
      this.isLoadingUpload = true;
      let router = this.$route;
      let formData   =  new FormData();
      formData.append('file', this.fileUpload);
      formData.append('payslipId',router.params.id);
      formData.append('endDate',utility.TimeStampToDate(this.dataCalculation.endDate));
      formData.append('startDate',utility.TimeStampToDate(this.dataCalculation.startDate));
      formData.append('period', this.dataCalculation.period);
      this.$http.put(`/payslip/payslip-upload/${router.params.id}`,formData)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this,result.data.message);
            this.fileUpload = null;
          } else {
            errorNotification(this,"Oops!",result.message);
          }
          this.isLoadingUpload = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.isLoadingUpload = false;
        });
    }
  }
}
</script>
